import { MessageRetailerOrBrandButton, additionalDataRequiredForContactingRetailerOrBrandCTA } from "../../shared/instantAnswerUtils";
import { getDeliveredAtDateFromIAContext } from "../../utils/getDeliveredAtDateFromIAContext";
import { orderCanBeReportedBasedOnDeliveryDate } from "../../utils/orderCanBeReportedBasedOnDeliveryDate";
import { DO_NOT_PROCESS_DAMAGED_AS_RETURN, INELIGIBLE_FOR_REPORT, NEED_MORE_INFO_ANSWER, getReportItemsOrRequestExtensionCTA } from "./shared";
export var ReportMissingItemIA = function ReportMissingItemIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getReportItemsOrRequ;
        return (_getReportItemsOrRequ = getReportItemsOrRequestExtensionCTA(context, strictLocalize)) === null || _getReportItemsOrRequ === void 0 ? void 0 : _getReportItemsOrRequ.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getReportItemsOrRequ2, _getReportItemsOrRequ3;
        return (_getReportItemsOrRequ2 = getReportItemsOrRequestExtensionCTA(context, strictLocalize)) === null || _getReportItemsOrRequ2 === void 0 ? void 0 : (_getReportItemsOrRequ3 = _getReportItemsOrRequ2.getLink) === null || _getReportItemsOrRequ3 === void 0 ? void 0 : _getReportItemsOrRequ3.call(_getReportItemsOrRequ2, context.brandOrder);
      }
    },
    secondaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _MessageRetailerOrBra;
        return (_MessageRetailerOrBra = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra === void 0 ? void 0 : _MessageRetailerOrBra.label;
      },
      onClickFunctionBuilder: function onClickFunctionBuilder(context) {
        var _MessageRetailerOrBra2;
        return (_MessageRetailerOrBra2 = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra2 === void 0 ? void 0 : _MessageRetailerOrBra2.onClick;
      }
    },
    additionalRequiredData: additionalDataRequiredForContactingRetailerOrBrandCTA()
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  var brandOrder = context.brandOrder,
    shippingContext = context.shippingContext;
  var deliveredAt = getDeliveredAtDateFromIAContext(context);
  if (!brandOrder || !shippingContext || !deliveredAt) {
    return NEED_MORE_INFO_ANSWER(strictLocalize);
  }
  return orderCanBeReportedBasedOnDeliveryDate(deliveredAt) ? MISSING_ITEM_REPORT_ELIGIBLE(strictLocalize) : MISSING_ITEM_REPORT_INELIGIBLE(strictLocalize);
};
var MISSING_ITEM_REPORT_ELIGIBLE = function MISSING_ITEM_REPORT_ELIGIBLE(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return RESOLVING_MISSING_ITEMS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [MESSAGE_BRAND_OR_FILE_REPORT(strictLocalize)];
    }
  };
};
var MISSING_ITEM_REPORT_INELIGIBLE = function MISSING_ITEM_REPORT_INELIGIBLE(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return INELIGIBLE_FOR_REPORT(strictLocalize);
    },
    getDescription: function getDescription() {
      return [MESSAGE_BRAND_TO_LEARN_MORE(strictLocalize), DO_NOT_PROCESS_DAMAGED_AS_RETURN(strictLocalize)];
    }
  };
};
var RESOLVING_MISSING_ITEMS = function RESOLVING_MISSING_ITEMS(strictLocalize) {
  return strictLocalize({
    id: "culXVL",
    defaultMessage: [{
      "type": 0,
      "value": "Resolver artigos em falta"
    }]
  });
};
var MESSAGE_BRAND_OR_FILE_REPORT = function MESSAGE_BRAND_OR_FILE_REPORT(strictLocalize) {
  return strictLocalize({
    id: "UVTf+D",
    defaultMessage: [{
      "type": 0,
      "value": "Pode enviar uma mensagem diretamente à marca sobre os seus artigos em falta ou usar o botão abaixo para comunicar um artigo em falta."
    }]
  });
};
var MESSAGE_BRAND_TO_LEARN_MORE = function MESSAGE_BRAND_TO_LEARN_MORE(strictLocalize) {
  return strictLocalize({
    id: "q0JMus",
    defaultMessage: [{
      "type": 0,
      "value": "Pode enviar uma mensagem à marca para saber mais sobre os artigos em falta ou solicitar uma extensão do prazo, caso existam circunstâncias excecionais."
    }]
  });
};